import Vue from 'vue'
import Router from 'vue-router'

import VueForm from '@/components/Form'
import VueCards from '@/components/Cards'
import NotFoundError from '@/components/404'
// Admin Components
import ANUConverter from '@/components/ANUConverter'
import AdminLayout from '@/components/admin/Layout'
import AdminHome from '@/components/admin/Home'
import AdminNewReservation from '@/components/admin/NewReservation'
import CarReservationDetails from '@/components/admin/CarReservationDetails'
import Reporting from '@/components/admin/Reporting'
import Notifications from '@/components/admin/Notifications'
import BatteryList from '@/components/admin/BatteryList'
import WashList from '@/components/admin/WashList'
import TollUpload from '@/components/admin/TollUpload'
import StrataReport from '@/components/admin/StrataReport'
import CouncilReport from '@/components/admin/CouncilReport'
import ApplicationAnalytics from '@/components/admin/ApplicationAnalytics'
import Retention from '@/components/admin/Retention'
import ANUUpload from '@/components/admin/ANUUpload'
import ReservationRefund from '@/components/admin/ReservationRefund'
import ViewHeldCharge from '@/components/admin/ViewHeldCharge'
// Object Displays
import ContractDetailsDisplay from '@/components/displays/ContractDetailsDisplay'
import RebatePromoDetailsDisplay from '@/components/displays/RebatePromoDetailsDisplay'
import CarDetailsDisplay from '@/components/displays/CarDetailsDisplay'
import CarMoveDisplay from '@/components/displays/CarMoveDisplay'
import ReservationDetailsDisplay from '@/components/displays/ReservationDetailsDisplay'
import AccountDetailsDisplay from '@/components/displays/AccountDetailsDisplay'
import AccountBillingDetailsDisplay from '@/components/displays/AccountBillingDetailsDisplay'
import AccountFilesDisplay from '@/components/displays/AccountFilesDisplay'
import RateDisplay from '@/components/displays/RateDisplay'
import ApplicationDetailsDisplay from '@/components/displays/ApplicationDetailsDisplay'
import SmartcardDisplay from '@/components/displays/SmartcardDisplay'
import TicketDetailsDisplay from '@/components/displays/TicketDetailsDisplay'
import AdminRequestDisplay from '@/components/displays/AdminRequestDisplay'
import BulkChargeDisplay from '@/components/displays/BulkChargeDisplay'

const render = function (h) {
  return h('div', [ h('router-view') ])
}

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '',
      component: AdminLayout,
      meta: {
        authType: 'admin'
      },
      children: [
        {
          path: '',
          component: AdminHome
        },
        {
          path: 'login',
          component: {
            name: 'Login',
            render (h) {
              return h('div',
                { class: 'row justify-content-md-center' },
                [h('div',
                  { class: 'col-md-6' },
                  [
                    h('h2', { class: 'mt-4 mb-4' }, ['Administrator Access Required']),
                    h('router-view')
                  ]
                )]
              )
            }
          },
          meta: {
            authType: 'public'
          },
          children: [
            {
              path: '',
              component: VueForm,
              meta: {
                authType: 'public',
                vueForm: 'adminLogin',
                vueFormMethod: 'post',
                loginPage: true
              }
            }
          ]
        },
        { path: 'dashboard', component: AdminHome },
        {
          path: 'follow-up',
          component: {
            name: 'FollowUp',
            render
          },
          children: [
            {
              path: '',
              redirect: 'notes'
            },
            {
              path: 'notes',
              component: VueCards,
              meta: {
                vueCards: 'notes',
                icon: 'fa-sticky-note',
                vueTitle: 'Notes',
                showSearch: true,
                allowExport: true
              }
            },
            {
              path: 'problems',
              component: {
                render,
                name: 'Problems'
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    vueCards: 'problems',
                    icon: 'fa-exclamation-circle',
                    vueTitle: 'Unresolved Problems',
                    showSearch: true
                  }
                },
                { path: ':problemUuid', component: AdminRequestDisplay }
              ]
            },
            {
              path: 'repairs',
              component: VueCards,
              meta: {
                vueCards: 'repairs',
                icon: 'fa-wrench',
                vueTitle: 'Damages',
                showSearch: true
              }
            },
            {
              path: 'resolved-problems',
              component: VueCards,
              meta: {
                vueCards: 'resolvedProblems',
                icon: 'fa-check',
                vueTitle: 'Resolved Problems',
                showSearch: true
              }
            }
          ]
        },
        {
          path: 'membership',
          component: {
            name: 'Membership',
            render
          },
          children: [
            {
              path: '',
              redirect: 'applications/completed'
            },
            {
              path: 'applications',
              component: {
                name: 'Applications',
                render,
                meta: {
                  allowExport: true
                }
              },
              children: [
                {
                  path: '',
                  redirect: 'completed'
                },
                {
                  path: 'completed',
                  component: VueCards,
                  meta: {
                    vueCards: 'applications',
                    icon: 'fa-user-plus',
                    vueTitle: 'Applications',
                    showSearch: true,
                    allowExport: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'declined',
                  component: VueCards,
                  meta: {
                    vueCards: 'declinedApplications',
                    icon: 'fa-ban',
                    vueTitle: 'Declined Applications',
                    showSearch: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'deleted',
                  component: VueCards,
                  meta: {
                    vueCards: 'deletedApplications',
                    icon: 'fa-trash',
                    vueTitle: 'Deleted Applications',
                    showSearch: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'incomplete',
                  component: VueCards,
                  meta: {
                    vueCards: 'incompleteApplications',
                    icon: 'fa-clipboard',
                    vueTitle: 'Incomplete Applications',
                    showSearch: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newApplication',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:account_id',
                  component: VueForm,
                  meta: {
                    vueForm: 'editAccount',
                    vueFormMethod: 'put'
                  }
                },
                { path: ':application_id', component: ApplicationDetailsDisplay }
              ]
            },
            {
              path: 'members',
              component: {
                name: 'Accounts',
                render,
                meta: {
                  allowExport: true
                }
              },
              children: [
                {
                  path: '',
                  redirect: 'all'
                },
                {
                  path: 'all/new',
                  redirect: 'new'
                },
                {
                  path: 'all',
                  component: VueCards,
                  meta: {
                    vueCards: 'accounts',
                    icon: 'fa-users',
                    vueTitle: 'Members',
                    showSearch: true,
                    allowNew: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'negative',
                  component: VueCards,
                  meta: {
                    icon: 'fa-hand-holding-usd',
                    vueCards: 'negativeMembers',
                    vueTitle: 'Negative Members',
                    showSearch: true,
                    allowNew: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'active',
                  component: VueCards,
                  meta: {
                    vueCards: 'activeMembers',
                    icon: 'fa-user',
                    vueTitle: 'Active Members',
                    showSearch: true,
                    allowNew: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'inactive',
                  component: VueCards,
                  meta: {
                    vueCards: 'inactiveMembers',
                    icon: 'fa-clock',
                    vueTitle: 'Inactive Members',
                    showSearch: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'restricted',
                  component: VueCards,
                  meta: {
                    vueCards: 'restrictedMembers',
                    icon: 'fa-ban',
                    vueTitle: 'Restricted Members',
                    showSearch: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'blacklisted',
                  component: VueCards,
                  meta: {
                    vueCards: 'blacklistedMembers',
                    icon: 'fa-gavel',
                    vueTitle: 'Blacklisted Members',
                    showSearch: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'quit',
                  component: VueCards,
                  meta: {
                    vueCards: 'quitMembers',
                    icon: 'fa-user-times',
                    vueTitle: 'Quit members',
                    showSearch: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newAccount',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:account_id',
                  component: VueForm,
                  meta: {
                    vueForm: 'editAccount',
                    vueFormMethod: 'put'
                  }
                },
                {
                  path: 'change-password/:account_id',
                  component: VueForm,
                  meta: {
                    vueForm: 'changePassword',
                    vueFormMethod: 'put'
                  }
                },
                { path: ':account_id', component: AccountDetailsDisplay },
                {
                  path: 'billing/:account_id',
                  component: AccountBillingDetailsDisplay
                },
                {
                  path: 'billing/preauth/:heldChargeUuid',
                  component: ViewHeldCharge
                },
                {
                  path: 'files/:account_id',
                  component: AccountFilesDisplay
                },
                {
                  path: 'bulkcharge',
                  component: BulkChargeDisplay
                }
              ]
            },
            {
              path: 'demos',
              component: {
                name: 'Demo Accounts',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    vueCards: 'demoAccounts',
                    icon: 'fa-handshake',
                    vueTitle: 'Demo Accounts',
                    allowNew: true,
                    showSearch: true,
                    allowExport: true,
                    tableDisplay: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newDemoAccount',
                    vueFormMethod: 'post'
                  }
                }
              ]
            },
            {
              path: 'plans',
              component: {
                name: 'Plans',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    vueCards: 'accountTypes',
                    icon: 'fa-file-alt',
                    vueTitle: 'Membership Plans',
                    allowNew: true,
                    newDisabled: true,
                    showSearch: true,
                    allowExport: true,
                    tableDisplay: true
                  }
                },
                {
                  path: 'edit/:type_id',
                  component: VueForm,
                  meta: {
                    vueForm: 'editAccountType',
                    vueFormMethod: 'put'
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newAccountType',
                    vueFormMethod: 'post'
                  }
                }
              ]
            },
            {
              path: 'direct-debit',
              component: {
                name: 'DirectDebit',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    vueCards: 'directDebits',
                    vueTitle: 'Direct Debits',
                    icon: 'fa-credit-card',
                    allowNew: true,
                    showSearch: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'edit/:chargeId',
                  component: VueForm,
                  meta: {
                    vueForm: 'editDirectDebit',
                    vueFormMethod: 'put'
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newDirectDebit',
                    vueFormMethod: 'post'
                  }
                }
              ]
            },
            {
              path: 'rates',
              component: {
                name: 'Rates',
                render
              },
              children: [
                {
                  path: '',
                  redirect: 'vehicles'
                },
                {
                  path: 'extras',
                  component: {
                    name: 'Extras',
                    render
                  },
                  children: [
                    {
                      path: '',
                      component: VueCards,
                      meta: {
                        vueCards: 'costs',
                        icon: 'fa-dollar-sign',
                        vueTitle: 'Costs',
                        showSearch: true,
                        allowNew: true,
                        newDisabled: true,
                        allowExport: true,
                        tableDisplay: true,
                        allowToggle: true
                      }
                    },
                    {
                      path: 'new',
                      component: VueForm,
                      meta: {
                        vueForm: 'newCost',
                        vueFormMethod: 'post'
                      }
                    },
                    {
                      path: 'edit/:cost_id',
                      component: VueForm,
                      meta: {
                        vueForm: 'editCost',
                        vueFormMethod: 'put'
                      }
                    }
                  ]
                },
                {
                  path: 'vehicles',
                  component: {
                    name: 'Rates',
                    render
                  },
                  children: [
                    {
                      path: '',
                      component: VueCards,
                      meta: {
                        vueCards: 'rates',
                        icon: 'fa-cart-plus',
                        vueTitle: 'Rates',
                        allowNew: true,
                        newDisabled: true,
                        showSearch: false,
                        allowExport: true,
                        tableDisplay: true
                      }
                    },
                    {
                      path: 'new',
                      component: VueForm,
                      meta: {
                        vueForm: 'newRate',
                        vueFormMethod: 'post'
                      }
                    },
                    {
                      path: 'edit/:rate_id',
                      component: VueForm,
                      meta: {
                        vueForm: 'editRate',
                        vueFormMethod: 'put'
                      }
                    },
                    {
                      path: ':rate_id',
                      component: RateDisplay
                    }
                  ]
                }
              ]
            },
            {
              path: 'smartcards',
              component: {
                name: 'Smartcards',
                render
              },
              children: [
                {
                  path: '/',
                  component: VueCards,
                  meta: {
                    vueCards: 'smartcards',
                    icon: 'fa-address-card',
                    vueTitle: 'Smartcards',
                    showSearch: true,
                    allowNew: true,
                    allowExport: true,
                    tableDisplay: true
                  }
                },
                {
                  path: 'edit/:smartcard_id',
                  component: VueForm,
                  meta: {
                    vueForm: 'editSmartcard',
                    vueFormMethod: 'put'
                  }
                },
                {
                  path: 'reassign/:smartcard_id',
                  component: VueForm,
                  meta: {
                    vueForm: 'reassignSmartcard',
                    vueFormMethod: 'put'
                  }
                },
                {
                  path: 'assign-captured/:smartcard_id',
                  component: VueForm,
                  meta: {
                    vueForm: 'assignCapturedSmartcard',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newSmartCard',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'new/:account_id',
                  component: VueForm,
                  meta: {
                    vueForm: 'newSmartcard',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'anu',
                  component: ANUConverter
                },
                {
                  path: ':smartcard_id',
                  component: SmartcardDisplay
                }
              ]
            },
            {
              path: 'promotions',
              component: {
                name: 'Promotions',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    vueCards: 'promos',
                    icon: 'fa-star',
                    vueTitle: 'Account Promos',
                    allowNew: true,
                    showSearch: true,
                    allowExport: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newPromo',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:promo',
                  component: VueForm,
                  meta: {
                    vueForm: 'editPromo',
                    vueFormMethod: 'put'
                  }
                }
              ]
            },
            {
              path: 'reservation-promotions',
              component: {
                name: 'ReservationPromos',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    vueCards: 'reservationPromos',
                    icon: 'fa-certificate',
                    vueTitle: 'Reservation Promos',
                    allowNew: true,
                    showSearch: true,
                    allowExport: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newReservationPromo',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:promo',
                  component: VueForm,
                  meta: {
                    vueForm: 'editReservationPromo',
                    vueFormMethod: 'put'
                  }
                }
              ]
            },
            {
              path: 'trailing-rebate-promotions',
              component: {
                name: 'TrailingRebatePromos',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    vueCards: 'trailingRebatePromos',
                    icon: 'fa-certificate',
                    vueTitle: 'Trailing Rebate Promos',
                    allowNew: true,
                    showSearch: true,
                    allowExport: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newTrailingRebatePromo',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:promo',
                  component: VueForm,
                  meta: {
                    vueForm: 'editTrailingRebatePromo',
                    vueFormMethod: 'put'
                  }
                },
                {
                  path: 'view/:promo',
                  component: RebatePromoDetailsDisplay
                }
              ]
            },
            {
              path: 'emails',
              component: {
                name: 'Emails',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    vueCards: 'emailTemplates',
                    icon: 'fa-envelope',
                    showSearch: true,
                    allowNew: true,
                    tableDisplay: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newEmailTemplate',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:emailTemplateUuid',
                  component: VueForm,
                  meta: {
                    vueForm: 'editEmailTemplate',
                    vueFormMethod: 'put'
                  }
                }
              ]
            },
            {
              path: 'messages',
              component: {
                name: 'Messages',
                render
              },
              children: [
                {
                  path: '',
                  redirect: '/membership/messages/notifications'
                },
                {
                  path: 'notifications',
                  component: VueCards,
                  meta: {
                    vueTitle: 'Account Messages',
                    vueCards: 'accountMessages',
                    icon: 'fa-bell',
                    allowNew: true
                  }
                },
                {
                  path: 'notifications/new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newAccountMessage',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'notifications/edit/:accountmessage_id',
                  component: VueForm,
                  meta: {
                    vueForm: 'editAccountMessage',
                    vueFormMethod: 'put'
                  }
                },
                {
                  path: 'dashboard',
                  component: VueCards,
                  meta: {
                    vueTitle: 'Dashboard Messages',
                    vueCards: 'dashboardMessages',
                    icon: 'fa-comment-alt',
                    allowNew: true
                  }
                },
                {
                  path: 'dashboard/new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newDashboardMessage',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'dashboard/edit/:dashboardmessage_id',
                  component: VueForm,
                  meta: {
                    vueForm: 'editDashboardMessage',
                    vueFormMethod: 'put'
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'fleet',
          component: {
            name: 'Fleet',
            render
          },
          children: [
            {
              path: '',
              redirect: 'reservations'
            },
            {
              path: 'reservations',
              component: {
                name: 'Reservations',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    vueCards: 'reservations',
                    vueTitle: 'Reservations',
                    icon: 'fa-calendar-alt',
                    showSearch: true,
                    allowNew: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                { path: 'new', component: AdminNewReservation },
                {
                  path: 'edit/:reservationUuid',
                  component: VueForm,
                  meta: {
                    vueForm: 'editReservation',
                    vueFormMethod: 'post'
                  }
                },
                { path: ':reservationUuid', component: ReservationDetailsDisplay },
                { path: 'refund/:reservationUuid', component: ReservationRefund },
                { path: 'vehicle/:carId', component: CarReservationDetails }
              ]
            },
            {
              path: 'maintenance',
              component: {
                name: 'Maintenance',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    icon: 'fa-wrench',
                    vueCards: 'maintenance',
                    vueTitle: 'Maintenance',
                    showSearch: true,
                    allowNew: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                { path: 'new', component: AdminNewReservation },
                { path: 'vehicle/:carId', component: CarReservationDetails }
              ]
            },
            {
              path: 'lots',
              component: {
                name: 'Lots',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    vueCards: 'lots',
                    vueTitle: 'Lots',
                    icon: 'fa-map-marker-alt',
                    allowNew: true,
                    showSearch: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newLot',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:lotId',
                  component: VueForm,
                  meta: {
                    vueForm: 'editLot',
                    vueFormMethod: 'put'
                  }
                }
              ]
            },
            {
              path: 'vehicles',
              component: {
                name: 'Vehicles',
                render
              },
              children: [
                {
                  path: '',
                  redirect: 'list'
                },
                {
                  path: 'list/new',
                  redirect: 'new'
                },
                {
                  path: 'list',
                  component: VueCards,
                  meta: {
                    vueCards: 'activeCars',
                    icon: 'fa-car',
                    vueTitle: 'Active Cars',
                    showSearch: true,
                    allowNew: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'unused',
                  component: VueCards,
                  meta: {
                    vueCards: 'unusedCars',
                    icon: 'fa-clock',
                    vueTitle: 'Unused Cars',
                    showSearch: true,
                    allowNew: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'retired',
                  component: VueCards,
                  meta: {
                    vueCards: 'retiredCars',
                    icon: 'fa-times-circle',
                    vueTitle: 'Retired Cars',
                    showSearch: true,
                    allowNew: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'sold',
                  component: VueCards,
                  meta: {
                    vueCards: 'soldCars',
                    icon: 'fa-check-circle',
                    vueTitle: 'Sold Cars',
                    showSearch: true,
                    allowNew: true,
                    allowExport: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newCar',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:carId',
                  component: VueForm,
                  meta: {
                    vueForm: 'editCar',
                    vueFormMethod: 'put'
                  }
                },
                { path: 'move/:carId', component: CarMoveDisplay },
                {
                  path: 'features',
                  component: {
                    name: 'Features',
                    render
                  },
                  children: [
                    {
                      path: '',
                      component: VueCards,
                      meta: {
                        vueCards: 'carFeatures',
                        icon: 'fa-list-ul',
                        vueTitle: 'Car Features',
                        allowNew: true,
                        allowExport: true,
                        tableDisplay: true
                      }
                    },
                    {
                      path: 'new',
                      component: VueForm,
                      meta: {
                        vueForm: 'newCarFeature',
                        vueFormMethod: 'post'
                      }
                    },
                    {
                      path: 'edit/:carFeature',
                      component: VueForm,
                      meta: {
                        vueForm: 'editCarFeature',
                        vueFormMethod: 'put'
                      }
                    }
                  ]
                },
                {
                  path: 'classes',
                  component: {
                    name: 'Classes',
                    render
                  },
                  children: [
                    {
                      path: '',
                      component: VueCards,
                      meta: {
                        vueCards: 'carClasses',
                        icon: 'fa-boxes',
                        vueTitle: 'Car Classes',
                        showSearch: false,
                        allowNew: true,
                        allowExport: true,
                        tableDisplay: true,
                        allowToggle: true
                      }
                    },
                    {
                      path: 'new',
                      component: VueForm,
                      meta: {
                        vueForm: 'newCarClass',
                        vueFormMethod: 'post'
                      }
                    },
                    {
                      path: 'edit/:carClass',
                      component: VueForm,
                      meta: {
                        vueForm: 'editCarClass',
                        vueFormMethod: 'put'
                      }
                    }
                  ]
                },
                {
                  path: 'types',
                  component: {
                    name: 'Types',
                    render
                  },
                  children: [
                    {
                      path: '',
                      component: VueCards,
                      meta: {
                        vueCards: 'carTypes',
                        icon: 'fa-taxi',
                        vueTitle: 'Car Models',
                        allowNew: true,
                        allowExport: true,
                        tableDisplay: true,
                        showSearch: true
                      }
                    },
                    {
                      path: 'new',
                      component: VueForm,
                      meta: {
                        vueForm: 'newCarType',
                        vueFormMethod: 'post'
                      }
                    },
                    {
                      path: 'edit/:type_id',
                      component: VueForm,
                      meta: {
                        vueForm: 'editCarType',
                        vueFormMethod: 'put'
                      }
                    }
                  ]
                },
                { path: ':carId', component: CarDetailsDisplay }
              ]
            },
            {
              path: 'relocate',
              component: {
                name: 'Relocations',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    vueCards: 'lotRelocations',
                    vueTitle: 'Lot Relocations',
                    icon: 'fa-compass',
                    showSearch: true,
                    allowExport: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newLotRelocation',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:relocationUuid',
                  component: VueForm,
                  meta: {
                    vueForm: 'editLotRelocation',
                    vueFormMethod: 'put'
                  }
                }
              ]
            },
            {
              path: 'restrictions',
              component: {
                name: 'Restrictions',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    icon: 'fa-lock',
                    vueCards: 'carRestrictions',
                    vueTitle: 'Car Restrictions',
                    allowNew: true,
                    tableDisplay: true,
                    allowToggle: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newCarRestriction',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:restriction_id',
                  component: VueForm,
                  meta: {
                    vueForm: 'editCarRestriction',
                    vueFormMethod: 'put'
                  }
                },
                { path: ':restriction_id', component: CarDetailsDisplay }
              ]
            },
            { path: 'tolls', component: TollUpload },
            {
              path: 'valets',
              component: {
                name: 'Valets',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    vueCards: 'valets',
                    icon: 'fa-key',
                    vueTitle: 'Valets',
                    allowNew: true,
                    showSearch: true,
                    allowExport: true,
                    allowToggle: true,
                    tableDisplay: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newValet',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:valet',
                  component: VueForm,
                  meta: {
                    vueForm: 'editValet',
                    vueFormMethod: 'put'
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'reports',
          component: {
            name: 'Reports',
            render
          },
          children: [
            { path: '', redirect: 'washlist' },
            { path: 'accounts', component: Reporting },
            { path: 'batterylist', component: BatteryList },
            { path: 'washlist', component: WashList },
            { path: 'strata', component: StrataReport },
            { path: 'council', component: CouncilReport },
            { path: 'applications', component: ApplicationAnalytics },
            { path: 'retention', component: Retention },
            { path: 'anu-export', component: ANUUpload }
          ]
        },
        {
          path: 'hardware',
          component: {
            name: 'Hardware',
            render
          },
          children: [
            {
              path: '',
              redirect: 'boxes'
            },
            {
              path: 'boxes',
              component: {
                name: 'Boxes',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    icon: 'fa-window-maximize',
                    vueCards: 'boxes',
                    vueTitle: 'Hardware Boxes',
                    showSearch: true,
                    allowExport: true,
                    allowNew: true,
                    tableDisplay: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newBox',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:boxId',
                  component: VueForm,
                  meta: {
                    vueForm: 'editBox',
                    vueFormMethod: 'put'
                  }
                }
              ]
            },
            {
              path: 'sim-cards',
              component: {
                name: 'SimCards',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    icon: 'fa-mobile',
                    vueCards: 'simcards',
                    vueTitle: 'Sim Cards',
                    allowExport: true,
                    showSearch: true,
                    allowNew: true,
                    tableDisplay: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newSimcard',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:simcardId',
                  component: VueForm,
                  meta: {
                    vueForm: 'editSimcard',
                    vueFormMethod: 'put'
                  }
                }
              ]
            },
            {
              path: 'petrol-cards',
              component: {
                name: 'PetrolCards',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    icon: 'fa-credit-card',
                    vueCards: 'petrolCards',
                    vueTitle: 'Petrol Cards',
                    showSearch: true,
                    allowNew: true,
                    tableDisplay: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newPetrolCard',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:petrolCardId',
                  component: VueForm,
                  meta: {
                    vueForm: 'editPetrolCard',
                    vueFormMethod: 'put'
                  }
                }
              ]
            },
            {
              path: 'nports',
              component: {
                name: 'NPorts',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    icon: 'fa-signal',
                    vueCards: 'nPorts',
                    vueTitle: 'NPorts',
                    allowExport: true,
                    allowNew: true,
                    tableDisplay: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newNPort',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:nPortId',
                  component: VueForm,
                  meta: {
                    vueForm: 'editNPort',
                    vueFormMethod: 'put'
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'contracts',
          component: {
            name: 'Contracts',
            render
          },
          children: [
            {
              path: '',
              redirect: 'terms'
            },
            {
              path: 'organisations',
              component: {
                name: 'Organisations',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    icon: 'fa-suitcase',
                    vueCards: 'organizations',
                    vueTitle: 'Organisations',
                    showSearch: true,
                    allowNew: true,
                    allowExport: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newOrganization',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:organization_id',
                  component: VueForm,
                  meta: {
                    vueForm: 'editOrganization',
                    vueFormMethod: 'put'
                  }
                }
              ]
            },
            {
              path: 'terms',
              component: {
                name: 'Organisations',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    icon: 'fa-file-alt',
                    vueCards: 'contracts',
                    vueTitle: 'Contracts',
                    showSearch: true,
                    allowNew: true,
                    allowExport: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newContract',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:contractId',
                  component: VueForm,
                  meta: {
                    vueForm: 'editContract',
                    vueFormMethod: 'put'
                  }
                },
                {
                  path: 'view/:contractId',
                  component: ContractDetailsDisplay
                }
              ]
            },
            {
              path: 'finance-codes',
              component: {
                name: 'FinanceCodes',
                render
              },
              children: [
                {
                  path: '',
                  component: VueCards,
                  meta: {
                    icon: 'fa-university',
                    vueCards: 'financeCodes',
                    vueTitle: 'Finance Codes',
                    tableDisplay: true,
                    showSearch: true,
                    allowNew: true
                  }
                },
                {
                  path: 'new',
                  component: VueForm,
                  meta: {
                    vueForm: 'newFinanceCode',
                    vueFormMethod: 'post'
                  }
                },
                {
                  path: 'edit/:codeId',
                  component: VueForm,
                  meta: {
                    vueForm: 'editFinanceCode',
                    vueFormMethod: 'put'
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'tickets',
          component: {
            name: 'Tickets',
            render
          },
          children: [
            {
              path: '',
              redirect: 'outstanding'
            },
            {
              path: 'outstanding/new',
              redirect: 'new'
            },
            {
              path: 'outstanding',
              component: VueCards,
              meta: {
                vueCards: 'tickets',
                icon: 'fa-ticket-alt',
                vueTitle: 'Outstanding Tickets',
                showSearch: true,
                allowNew: true
              }
            },
            {
              path: 'completed',
              component: VueCards,
              meta: {
                vueCards: 'completedTickets',
                icon: 'fa-check-square',
                vueTitle: 'Completed Tickets',
                showSearch: true
              }
            },
            {
              path: 'new',
              component: VueForm,
              meta: {
                vueForm: 'newTicket',
                vueFormMethod: 'post'
              }
            },
            { path: ':ticketId', component: TicketDetailsDisplay }
          ]
        },
        {
          path: 'preferences',
          component: VueForm,
          meta: {
            vueForm: 'editPreferences',
            vueFormMethod: 'post'
          }
        },
        {
          path: 'notifications',
          component: Notifications,
          meta: {
            public: false
          }
        },
        {
          path: '*',
          component: NotFoundError,
          meta: {
            public: false
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js